module.exports = __webpack_public_path__ + "static/media/atlascopco.0cac0f43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/atlascopco.png
// module id = 945
// module chunks = 0